<template>
    <div class="team-member team-member__section-plugin">
        <!-- <pre v-if="content" v-text="content"></pre> -->

        <div class="team-member--root">
        <div class="team-member--identity" ref="teamMember" :class="{ visible: isVisible }">
                <img v-bind="imageData" class="team-member--image" :class="{'team-member--image-primary': hoverImageData.src !== imageData.src}">
                <img v-if="hoverImageData.src !== imageData.src" v-bind="hoverImageData" class="team-member--image team-member--image-secondary">
                <div class="team-member--description">
                    <h3 class="team-member--name" v-text="content.name"></h3>
                    <span class="team-member--job-title" v-html="content.job"></span>
                    <div class="team-member--contact">
                        <a :href="content.email_link" class="team-member--contact-email u-reset">
                            <cmp-icon symbol="mail" size="small"></cmp-icon>
                        </a>
                        <a :href="content.phone_link" class="team-member--contact-phone u-reset">
                            <cmp-icon symbol="phone" size="small"></cmp-icon>
                        </a>
                        <span v-html="content.phone_label"></span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapFilters } from 'util/vue/map-filters';
    import cmsPlugin from 'vue/mixins/cms/cms-plugin';
    import bemMixin from 'vue/mixins/bem';


    const FALLBACK_IMAGE_URL = 'img/fallback.jpg';


    export default {
        mixins: [
            bemMixin('team-member'),
            cmsPlugin,
        ],
        data() {
            return {
                isVisible: false,
                observer: null,
            };
        },
        mounted() {
            if (window.matchMedia('(hover: none)').matches) {
                this.initIntersectionObserver();
            }
        },
        computed: {
            imageData() {
                const image = this.content.image || {};

                return {
                    src: image.url || this.static(FALLBACK_IMAGE_URL),
                    alt: image.alt,
                };
            },
             
            hoverImageData() {
                const image = this.content.hover_image || {};

                return {
                    src: image.url || this.static(FALLBACK_IMAGE_URL),
                    alt: image.alt,
                };
            },
        },
        methods: {
            ...mapFilters(['static']),
            initIntersectionObserver() {
                this.observer = new IntersectionObserver((entries) => {
                    entries.forEach((entry) => {
                        this.isVisible = entry.isIntersecting;
                    });
                }, { threshold: 0, rootMargin: '0% 0% -80% 0%' });

                this.observer.observe(this.$refs.teamMember);
            },
        },
        beforeUnmount() {
            if (this.observer) {
                this.observer.disconnect();
            }
        },
    };
</script>



// WEBPACK FOOTER //
// index.vue?52e22114